import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { ApiClientService } from "~app/common/services/api-client.service";
import { IMattslagRequest, IMattslagResponse, IMattslagskonverteringBasData, MattslagSaveRequest } from "./mattslagskonvertering.models";

@Injectable({
    providedIn: "root"
})
export class MattslagskonverteringService {
    private readonly apiClient = inject(ApiClientService);

    getMattslagBasdata(): Observable<IMattslagskonverteringBasData> {
        return this.apiClient.get("RaskCommon/GetMattslagskonverteringBasData", true);
    }

    getMattslag(request: IMattslagRequest): Observable<IMattslagResponse> {
        return this.apiClient.post(`RaskCommon/GetMattslagskonvertering`,
            {
                marknadsomradeId: request.marknadsomradeId,
                resultatomradeId: request.resultatomradeId,
                mattslagId: request.mattslagId
            }, true);
    }

    saveMattslag(mattslagData: MattslagSaveRequest): Observable<IMattslagResponse> {
        return this.apiClient.post(`RaskCommon/SaveMattslagskonvertering`, mattslagData, true);
    }
}
